module.exports = __webpack_public_path__ + "img/picto-login.321ef022.svg";